import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export function pendingChangesGuard(
    component: any,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if(!component.formSubmitted ){
        return component.showWarningMessageDialog();
    }
    return true
}
  